document.addEventListener('DOMContentLoaded', () => {

  /* ───────────────────────────────
     1. Ensure an overlay exists
     ─────────────────────────────── */
  const overlay = document.querySelector('.sticky-bar__overlay') || (() => {
    const o = document.createElement('div');
    o.className = 'sticky-bar__overlay';   // CSS handles opacity + pointer-events
    document.body.appendChild(o);
    return o;
  })();

  /* ───────────────────────────────
     2. Init every sticky bar
     ─────────────────────────────── */
  document.querySelectorAll('.sticky-product-bar').forEach(bar => {
    const toggleBtn  = bar.querySelector('.sticky-bar__toggle');
    const mobileMenu = bar.querySelector('.sticky-bar__mobile-menu');
    if (!toggleBtn || !mobileMenu) return;          // safety guard

    /* start closed (just in case) */
    mobileMenu.classList.remove('show');
    toggleBtn.setAttribute('aria-expanded', 'false');

    /* helper fns */
    const open  = () => {
      mobileMenu.classList.add('show');
      overlay.classList.add('show');
      document.body.classList.add('no-scroll');
      toggleBtn.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      mobileMenu.classList.remove('show');
      overlay.classList.remove('show');
      document.body.classList.remove('no-scroll');
      toggleBtn.setAttribute('aria-expanded', 'false');
    };

    // Close menu when any link is clicked inside the menu
      mobileMenu.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
          /* MOBILE ONLY (adjust breakpoint if you use a different one) */
          if (window.innerWidth > 749) return;
    
          e.preventDefault();                       // stop native jump
          const targetId   = link.getAttribute('href').slice(1);
          const targetEl   = document.getElementById(targetId);
          if (!targetEl) return;                    // safety
    
          /* measure bar height BEFORE we close the menu */
          const offset     = bar.offsetHeight;      // sticky bar + logo row etc.
    
          close();                                  // collapse menu first
    
          /* scroll exactly to the section minus the dynamic offset */
          window.scrollTo({
            top: targetEl.offsetTop - offset,
            behavior: 'smooth'
          });
        });
     });

    /* open / close via chevron */
    toggleBtn.addEventListener('click', e => {
      e.stopPropagation();
      mobileMenu.classList.contains('show') ? close() : open();
    });

    /* click on overlay also closes */
    overlay.addEventListener('click', close);

    /* click anywhere outside this bar closes */
    document.addEventListener('click', e => {
      if (!bar.contains(e.target) && !overlay.contains(e.target)) close();
    });

    /* ESC key closes */
    window.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  });
});
